// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"359f8521","455":"08114be5"}[chunkId] + ".chunk.js";
};